// ======================================================================
// File Name       : RouteConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import TopContainer from '../containers/TopContainer';
import * as Functions from './FunctionConstants';
import * as Path from './PathConstants';

// Enterprise
import EnterpriseListContainer from '../containers/enterprise/EnterpriseListContainer';
import EnterpriseNoticeDetailContainer from '../containers/enterprise/EnterpriseNoticeDetailContainer';
import EnterpriseNoticeEditContainer from '../containers/enterprise/EnterpriseNoticeEditContainer';
import EnterpriseNoticeRegisterContainer from '../containers/enterprise/EnterpriseNoticeRegisterContainer';

// Course
import CourseDefaultThumbnailContainer from '../containers/course/CourseDefaultThumbnailContainer';
import CourseListContainer from '../containers/course/CourseListContainer';
// Content Video
import ContentVideoContainer from '../containers/content/ContentVideoContainer';
import ContentVideoDetailContainer from '../containers/content/ContentVideoDetailContainer';
import ContentVideoNewEditContainer from '../containers/content/ContentVideoNewEditContainer';

// Content Question
import ContentQuestionAttributeContainer from '../containers/content/ContentQuestionAttributeContainer';
import ContentQuestionDetailContainer from '../containers/content/ContentQuestionDetailContainer';
import ContentQuestionEditContainer from '../containers/content/ContentQuestionEditContainer';
import ContentQuestionNewContainer from '../containers/content/ContentQuestionNewContainer';
import EachQuestionAttributeListContainer from '../containers/content/EachQuestionAttributeListContainer';

// User
import UserDetailContainer from '../containers/user/UserDetailContainer';
import UserRegistUpdateContainner from '../containers/user/UserRegistUpdateContainner';
import UserTopContainer from '../containers/user/UserTopContainer';

// Group
import GroupListContainer from '../containers/group/GroupListContainer';

// Account
import AccountEditContainer from '../containers/account/AccountEditContainer';

//  Service
import ServiceDetailContainer from '../containers/service/ServiceDetailContainer';
import ServiceNoticeEditContainer from '../containers/service/ServiceNoticeEditContainer';
import ServiceNoticeRegisterContainer from '../containers/service/ServiceNoticeRegisterContainer';
import ServiceNotificationDetailContainer from '../containers/service/ServiceNotificationDetailContainer';
import ServiceNotificationListContainer from '../containers/service/ServiceNotificationListContainer';
import ServiceRecordContainer from '../containers/service/ServiceRecordContainer';
import ServiceRegisterEditContainer from '../containers/service/ServiceRegisterEditContainer';
import ServiceSystemUsageListContainer from '../containers/service/ServiceSystemUsageListContainer';
import ServiceTopContainer from '../containers/service/ServiceTopContainer';

//  Authority
import AuthorityDetailContainer from '../containers/authority/AuthorityDetailContainer';
import AuthorityRegisterEditContainer from '../containers/authority/AuthorityRegisterEditContainer';
import AuthorityTopContainer from '../containers/authority/AuthorityTopContainer';

// Super user
import SuperUserDetailContainer from '../containers/superUser/SuperUserDetailContainer';
import SuperUserRegistUpdateContainner from '../containers/superUser/SuperUserRegistUpdateContainner';
import SuperUserTopContainer from '../containers/superUser/SuperUserTopContainer';

// サービス選択画面
import ServiceLoginContainer from '../containers/ServiceLoginContainer';

// Content Distribution
import ContentDistributionListContainer from '../containers/contentDistribution/ContentDistributionListContainer';
import ContentDistributionRegisterEditContainer from '../containers/contentDistribution/ContentDistributionRegisterEditContainer';
import ContentDistributionUsageDetail from '../containers/contentDistribution/ContentDistributionUsageDetail';
import DistributionOfferListDetailContainer from '../containers/contentDistribution/DistributionOfferListDetailContainer';

// Content Document
import ContentDocumentContainer from '../containers/content/ContentDocumentContainer';
import ContentDocumentDetailContainer from '../containers/content/ContentDocumentDetailContainer';
import InitializeFromStateForm from '../containers/content/ContentDocumentEditContainer';
import ContentDocumentRegisterContainer from '../containers/content/ContentDocumentRegisterContainer';
// Content Drill
import ContentDrillDetailContainer from '../containers/content/ContentDrillDetailContainer';
import ContentDrillEditionContainer from '../containers/content/ContentDrillEditionContainer';
import ContentDrillRegister from '../containers/content/ContentDrillRegisterContainer';

// Content Drill Skin
import ContentDrillSkinContainer from '../containers/content/ContentDrillSkinContainer';
import ContentDrillSkinDetailContainer from '../containers/content/ContentDrillSkinDetailContainer';
import ContentDrillSkinRegistUpdateContainner from '../containers/content/ContentDrillSkinRegistUpdateContainner';

// notification
import EnterpriseNotificationListContainer from '../containers/enterpriseNotification/EnterpriseNotificationListContainer';

// Content Notification
import ContentNotificationDetailContainer from '../containers/content/ContentNotificationDetailContainer';
import ContentNotificationRegisterUpdateContainer from '../containers/content/ContentNotificationRegisterUpdateContainer';
import ContentNotificationTopContainer from '../containers/content/ContentNotificationTopContainer';

// Archivement
import ArchivementDetailContainer from '../containers/archivement/ArchivementDetailContainer';
import ArchivementListContainer from '../containers/archivement/ArchivementListContainer';

// Content Link
import ContentLinkDetailContainer from '../containers/content/ContentLinkDetailContainer';
import ContentLinkRegisterContainer from '../containers/content/ContentLinkRegisterContainer';

// Scoring Distribution
import DistributionReportContainer from '../containers/report/distribution/DistributionReportContainer';

// Import Container
import ImportContainer from '../containers/ImportContainer';

import ReportContainer from '../containers/report/scoring/ScoringReportContainer';

// User History
import LivePerformanceDetailContainer from '../containers/livePerformance/LivePerformanceDetailContainer';
import LivePerformanceListContainer from '../containers/livePerformance/LivePerformanceListContainer';
import ContentHistoryAggregateByProblemContainer from '../containers/userHistory/content/ContentHistoryAggregateByProblemContainer'; // #7386
import ContentHistoryDetailContainer from '../containers/userHistory/content/ContentHistoryDetailContainer';
import UserHistoryCourseDetailContainer from '../containers/userHistory/course/UserHistoryCourseDetailContainer';
import ParticipantDetailContainer from '../containers/userHistory/participant/ParticipantDetailContainer';
import ParticipantListContainer from '../containers/userHistory/participant/ParticipantListContainer';
import UserHistoryStudentDetailContainer from '../containers/userHistory/student/UserHistoryStudentDetailContainer';
import UserHistoryStudentResultContainer from '../containers/userHistory/student/UserHistoryStudentResultContainer';

// Scoring unsubmitted report
import UnsubmittedReportContainer from '../containers/report/unsubmitted/UnsubmittedReportContainer';

// Message thread
import ChatContainer from '../containers/messageThread/ChatContainer';
import MessageThreadDetailContainer from '../containers/messageThread/MessageThreadDetailContainer';
import RegisterMessageContainer from '../containers/messageThread/RegisterMessageContainer';

// Usage Setting Live
import LiveReservedDetailContainer from '../containers/usageSettingLive/LiveReservedDetailContainer';
import LiveReservedEditContainer from '../containers/usageSettingLive/LiveReservedEditContainer';
import LiveReservedListContainer from '../containers/usageSettingLive/LiveReservedListContainer';
import LiveReservedRegisterContainer from '../containers/usageSettingLive/LiveReservedRegisterContainer';

// Adaptive
import AdaptiveMetaContainer from '../containers/adaptive/AdaptiveMetaContainer';
import DiscriminationDegreeDataContainer from '../containers/adaptive/DiscriminationDegreeDataContainer';

// CSV Download
import LearningHistoryCSVDownloadContainer from '../containers/userHistory/csv/LearningHistoryCSVDownloadContainer';
import ProgressStatusCSVDownloadContainer from '../containers/userHistory/csv/ProgressStatusCSVDownloadContainer';

// config file
import DownloadConfigFileContainer from '../containers/configFile/DownloadConfigFileContainer';
import UploadConfigFileContainer from '../containers/configFile/UploadConfigFileContainer';

// Email
import EmailEditContainer from '../containers/email/EmailEditContainer';
import EmailListContainer from '../containers/email/EmailListContainer';
import EmailRegisterContainer from '../containers/email/EmailRegisterContainer';

// Reserved Email
import ReservedEmailDetailContainer from '../containers/email/ReservedEmailDetailContainer';
import ReservedEmailListContainer from '../containers/email/ReservedEmailListContainer';

// 多言語表示
import MultiLanguageEditContainer from '../containers/multiLanguage/MultiLanguageEditContainer';
import MultiLanguageListContainer from '../containers/multiLanguage/MultiLanguageListContainer';
import MultiLanguageProcessDetailContainer from '../containers/multiLanguage/MultiLanguageProcessDetailContainer';
import MultiLanguageProcessResultListContainer from '../containers/multiLanguage/MultiLanguageProcessResultListContainer';

// 受講者画面
import UserfrontLoginScreenContainer from '../containers/userfront/UserfrontLoginScreenContainer';
import UserfrontTopScreenContainer from '../containers/userfront/UserfrontTopScreenContainer';

// TabMenu画面
import TabMenuContainer from '../containers/TabMenuContainer';
import ContentLinkListContainer from '../containers/content/ContentLinkListContainer';

import ServiceGroupDetailContainer from '../containers/serviceGroup/ServiceGroupDetailContainer';
import ServiceGroupTopContainer from '../containers/serviceGroup/ServiceGroupTopContainer';
import SuperuserServiceRoleTopContainer from '../containers/superuserServiceRole/SuperuserServiceRoleTopContainer';
import SuperuserServiceRoleRegisterEditContainer from '../containers/superuserServiceRole/SuperuserServiceRoleRegisterEditContainer';
import SuperuserServiceRoleDetailContainer from '../containers/superuserServiceRole/SuperuserServiceRoleDetailContainer';
import SuperuserEnterpriseRoleTopContainer from '../containers/superuserEnterpriseRole/SuperuserEnterpriseRoleTopContainer';
import SuperuserEnterpriseRoleDetailContainer from '../containers/superuserEnterpriseRole/SuperuserEnterpriseRoleDetailContainer';
import SuperuserEnterpriseRoleRegisterEditContainer from '../containers/superuserEnterpriseRole/SuperuserEnterpriseRoleRegisterEditContainer';
import LoginHistoryCSVDownloadContainer from '../containers/userHistory/csv/LoginHistoryCSVDownloadContainer';

const ROUTE_CONFIG = {
  // Step9.0.0 START
  [Path.ROUTE_LOGIN]: [
    {
      id: Functions.TOP,
      path: Path.TOP_LIST,
      container: TopContainer,
    },
  ],
  // Step9.0.0 END
  // パスワード変更画面
  [Path.TOP]: [
    {
      id: Functions.TOP,
      path: Path.TOP_LIST,
      container: TopContainer,
    },
  ],
  // SuperUser向け業務選択画面
  [Path.SERVICE_LOGIN]: [
    {
      id: Functions.SERVICE_LOGIN,
      path: Path.SERVICE_LOGIN_LIST,
      container: ServiceLoginContainer,
    },
  ],

  // 企業管理画面
  [Path.ENTERPRISE]: [
    {
      id: Functions.ENTERPRISE_LIST,
      path: Path.ENTERPRISE_LIST,
      container: EnterpriseListContainer,
    },
    {
      id: Functions.ENTERPRISE_IMPORT,
      path: Path.ENTERPRISE_IMPORT,
      container: ImportContainer,
    },
  ],

  // 企業向けお知らせ画面
  [Path.NOTICE]: [
    {
      id: Functions.ENTERPRISE_NOTIFICATION_LIST,
      path: Path.ENTERPRISE_NOTIFICATION_LIST,
      container: EnterpriseNotificationListContainer,
    },
    {
      id: Functions.ENTERPRISE_NOTIFICATION_REGISTER,
      path: Path.ENTERPRISE_NOTIFICATION_REGISTER,
      container: EnterpriseNoticeRegisterContainer,
    },
    {
      id: Functions.ENTERPRISE_NOTIFICATION_IMPORT,
      path: Path.ENTERPRISE_NOTIFICATION_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.ENTERPRISE_NOTIFICATION_EDIT,
      path: Path.ENTERPRISE_NOTIFICATION_EDIT,
      container: EnterpriseNoticeEditContainer,
    },
    {
      id: Functions.ENTERPRISE_NOTIFICATION_DETAIL,
      path: Path.ENTERPRISE_NOTIFICATION_DETAIL,
      container: EnterpriseNoticeDetailContainer,
    },
    {
      id: Functions.SERVICE_NOTIFICATION_LIST,
      path: Path.SERVICE_NOTIFICATION_LIST,
      container: ServiceNotificationListContainer,
    },
    {
      id: Functions.SERVICE_NOTIFICATION_EDIT,
      path: Path.SERVICE_NOTIFICATION_EDIT,
      container: ServiceNoticeEditContainer,
    },
    {
      id: Functions.SERVICE_NOTIFICATION_REGISTER,
      path: Path.SERVICE_NOTIFICATION_REGISTER,
      container: ServiceNoticeRegisterContainer,
    },
    {
      id: Functions.SERVICE_NOTIFICATION_IMPORT,
      path: Path.SERVICE_NOTIFICATION_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.SERVICE_NOTIFICATION_DETAIL,
      path: Path.SERVICE_NOTIFICATION_DETAIL,
      container: ServiceNotificationDetailContainer,
    },
  ],

  // Superuser
  [Path.SUPERUSER]: [
    {
      id: Functions.SUPERUSER_LIST,
      path: Path.SUPERUSER_LIST,
      container: SuperUserTopContainer,
    },
    {
      id: Functions.SUPERUSER_EDIT,
      path: Path.SUPERUSER_EDIT,
      container: SuperUserRegistUpdateContainner,
    },
    {
      id: Functions.SUPERUSER_REGISTER,
      path: Path.SUPERUSER_REGISTER,
      container: SuperUserRegistUpdateContainner,
    },
    {
      id: Functions.SUPERUSER_IMPORT,
      path: Path.SUPERUSER_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.SUPERUSER_DETAIL,
      path: Path.SUPERUSER_DETAIL,
      container: SuperUserDetailContainer,
    },
  ],

  // ユーザー管理画面
  [Path.USER]: [
    {
      id: Functions.USER_LIST,
      path: Path.USER_LIST,
      container: UserTopContainer,
    },
    {
      id: Functions.USER_EDIT,
      path: Path.USER_EDIT,
      container: UserRegistUpdateContainner,
    },
    {
      id: Functions.USER_REGISTER,
      path: Path.USER_REGISTER,
      container: UserRegistUpdateContainner,
    },
    {
      id: Functions.USER_IMPORT,
      path: Path.USER_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.USER_DETAIL,
      path: Path.USER_DETAIL,
      container: UserDetailContainer,
    },
  ],

  // ユーザーグループ管理画面
  [Path.GROUP]: [
    {
      id: Functions.GROUP_LIST,
      path: Path.GROUP_LIST,
      container: GroupListContainer,
    },
    {
      id: Functions.GROUP_IMPORT,
      path: Path.GROUP_IMPORT,
      container: ImportContainer,
    },
  ],

  // アカウント管理
  [Path.ACCOUNT]: [
    {
      id: Functions.ACCOUNT_EDIT,
      path: Path.ACCOUNT_EDIT,
      container: AccountEditContainer,
    },
  ],

  /**
   * コース管理画面
   */
  [Path.COURSE]: [
    {
      id: Functions.COURSE_LIST,
      path: Path.COURSE_LIST,
      container: CourseListContainer,
    },
    {
      id: Functions.COURSE_IMPORT,
      path: Path.COURSE_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.COURSE_THUMBNAIL_UPDATE,
      path: Path.COURSE_THUMBNAIL_UPDATE,
      container: TabMenuContainer,
    },
  ],

  [Path.CONTENT]: [
    {
      id: Functions.CONTENT_LIST,
      path: Path.CONTENT_LIST,
      container: TabMenuContainer,
    },
      // Step9.0.1 START
    {
      id: Functions.CONTENT_VIDEO_LIST,
      path: Path.CONTENT_VIDEO_LIST,
      container: ContentVideoContainer,
    },
    {
      id: Functions.CONTENT_DOCUMENT_LIST,
      path: Path.CONTENT_DOCUMENT_LIST,
      container: ContentDocumentContainer,
    },
    {
      id: Functions.CONTENT_LINK_LIST,
      path: Path.CONTENT_LINK_LIST,
      container: ContentLinkListContainer,
    },
      // Step9.0.1 END
    {
      id: Functions.CONTENT_VIDEO_REGISTER,
      path: Path.CONTENT_VIDEO_REGISTER,
      container: ContentVideoNewEditContainer,
    },
    {
      id: Functions.CONTENT_VIDEO_IMPORT,
      path: Path.CONTENT_VIDEO_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_VIDEO_EDIT,
      path: Path.CONTENT_VIDEO_EDIT,
      container: ContentVideoNewEditContainer,
    },
    {
      id: Functions.CONTENT_VIDEO_DETAIL,
      path: Path.CONTENT_VIDEO_DETAIL,
      container: ContentVideoDetailContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_LIST,
      path: Path.CONTENT_QUESTION_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_IMPORT,
      path: Path.CONTENT_QUESTION_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_DRILL_LIST,
      path: Path.CONTENT_DRILL_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_REGISTER,
      path: Path.CONTENT_QUESTION_REGISTER,
      container: ContentQuestionNewContainer,
    },
    {
      id: Functions.CONTENT_DRILL_REGISTER,
      path: Path.CONTENT_DRILL_REGISTER,
      container: ContentDrillRegister,
    },
    {
      id: Functions.CONTENT_DRILL_IMPORT,
      path: Path.CONTENT_DRILL_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_DRILL_EDIT,
      path: Path.CONTENT_DRILL_EDIT,
      container: ContentDrillEditionContainer,
    },
    {
      id: Functions.CONTENT_DRILL_DETAIL,
      path: Path.CONTENT_DRILL_DETAIL,
      container: ContentDrillDetailContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_ATTRIBUTE_LIST,
      path: Path.CONTENT_QUESTION_ATTRIBUTE_LIST,
      container: ContentQuestionAttributeContainer,
    },
    {
      id: Functions.PREVIEW_EACH_QUESTION_ATTRIBUTE,
      path: Path.PREVIEW_EACH_QUESTION_ATTRIBUTE,
      container: EachQuestionAttributeListContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_EDIT,
      path: Path.CONTENT_QUESTION_EDIT,
      container: ContentQuestionEditContainer,
    },
    {
      id: Functions.CONTENT_QUESTION_DETAIL,
      path: Path.CONTENT_QUESTION_DETAIL,
      container: ContentQuestionDetailContainer,
    },
    {
      id: Functions.CONTENT_DRILL_SKIN_LIST,
      path: Path.CONTENT_DRILL_SKIN_LIST,
      container: ContentDrillSkinContainer,
    },
    {
      id: Functions.CONTENT_DRILL_SKIN_REGISTER,
      path: Path.CONTENT_DRILL_SKIN_REGISTER,
      container: ContentDrillSkinRegistUpdateContainner,
    },
    {
      id: Functions.CONTENT_DRILL_SKIN_EDIT,
      path: Path.CONTENT_DRILL_SKIN_EDIT,
      container: ContentDrillSkinRegistUpdateContainner,
    },
    {
      id: Functions.CONTENT_DRILL_SKIN_DETAIL,
      path: Path.CONTENT_DRILL_SKIN_DETAIL,
      container: ContentDrillSkinDetailContainer,
    },
    {
      id: Functions.CONTENT_DRILL_NOTIFICATION_LIST,
      path: Path.CONTENT_DRILL_NOTIFICATION_LIST,
      container: ContentNotificationTopContainer,
    },
    {
      id: Functions.CONTENT_DRILL_NOTIFICATION_REGISTER,
      path: Path.CONTENT_DRILL_NOTIFICATION_REGISTER,
      container: ContentNotificationRegisterUpdateContainer,
    },
    {
      id: Functions.CONTENT_DRILL_NOTIFICATION_EDIT,
      path: Path.CONTENT_DRILL_NOTIFICATION_EDIT,
      container: ContentNotificationRegisterUpdateContainer,
    },
    {
      id: Functions.CONTENT_DRILL_NOTIFICATION_DETAIL,
      path: Path.CONTENT_DRILL_NOTIFICATION_DETAIL,
      container: ContentNotificationDetailContainer,
    },
    {
      id: Functions.CONTENT_LINK_REGISTER,
      path: Path.CONTENT_LINK_REGISTER,
      container: ContentLinkRegisterContainer,
    },
    {
      id: Functions.CONTENT_LINK_IMPORT,
      path: Path.CONTENT_LINK_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_LINK_EDIT,
      path: Path.CONTENT_LINK_EDIT,
      container: ContentLinkRegisterContainer,
    },
    {
      id: Functions.CONTENT_LINK_DETAIL,
      path: Path.CONTENT_LINK_DETAIL,
      container: ContentLinkDetailContainer,
    },
    {
      id: Functions.CONTENT_DOCUMENT_REGISTER,
      path: Path.CONTENT_DOCUMENT_REGISTER,
      container: ContentDocumentRegisterContainer,
    },
    {
      id: Functions.CONTENT_DOCUMENT_IMPORT,
      path: Path.CONTENT_DOCUMENT_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_DOCUMENT_EDIT,
      path: Path.CONTENT_DOCUMENT_EDIT,
      container: InitializeFromStateForm,
    },
    {
      id: Functions.CONTENT_DOCUMENT_DETAIL,
      path: Path.CONTENT_DOCUMENT_DETAIL,
      container: ContentDocumentDetailContainer,
    },
  ],

  /**
   * サービス管理画面
   */
  [Path.SERVICE]: [
    {
      id: Functions.SERVICE_LIST,
      path: Path.SERVICE_LIST,
      container: ServiceTopContainer,
    },
    {
      id: Functions.SERVICE_DETAIL,
      path: Path.SERVICE_DETAIL,
      container: ServiceDetailContainer,
    },
    {
      id: Functions.SERVICE_DETAIL_MENU_NONE,
      path: Path.SERVICE_DETAIL_MENU_NONE,
      container: ServiceDetailContainer,
    },
    {
      id: Functions.SERVICE_EDIT,
      path: Path.SERVICE_EDIT,
      container: ServiceRegisterEditContainer,
    },
    {
      id: Functions.SERVICE_REGISTER,
      path: Path.SERVICE_REGISTER,
      container: ServiceRegisterEditContainer,
    },
    {
      id: Functions.SERVICE_IMPORT,
      path: Path.SERVICE_IMPORT,
      container: ImportContainer,
    },
  ],
  /**
   * 権限ロール管理画面
   */
  [Path.AUTHORITY]: [
    {
      id: Functions.AUTHORITY_LIST,
      path: Path.AUTHORITY_LIST,
      container: AuthorityTopContainer,
    },
    {
      id: Functions.AUTHORITY_EDIT,
      path: Path.AUTHORITY_EDIT,
      container: AuthorityRegisterEditContainer,
    },
    {
      id: Functions.AUTHORITY_REGISTER,
      path: Path.AUTHORITY_REGISTER,
      container: AuthorityRegisterEditContainer,
    },
    {
      id: Functions.AUTHORITY_IMPORT,
      path: Path.AUTHORITY_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.AUTHORITY_DETAIL,
      path: Path.AUTHORITY_DETAIL,
      container: AuthorityDetailContainer,
    },
  ],

  [Path.CONTENT_DISTRIBUTION]: [
    {
      id: Functions.CONTENT_DISTRIBUTION_LIST,
      path: Path.CONTENT_DISTRIBUTION_LIST,
      container: ContentDistributionListContainer,
    },
    {
      id: Functions.CONTENT_DISTRIBUTION_IMPORT,
      path: Path.CONTENT_DISTRIBUTION_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.COURSE_DISTRIBUTION_IMPORT,
      path: Path.COURSE_DISTRIBUTION_IMPORT,
      container: ImportContainer,
    },
    {
      id: Functions.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT,
      path: Path.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT,
      container: ContentDistributionRegisterEditContainer,
    },
    {
      id: Functions.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL,
      path: Path.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL,
      container: DistributionOfferListDetailContainer,
    },
    {
      id: Functions.CONTENT_DISTRIBUTION_REGISTER,
      path: Path.CONTENT_DISTRIBUTION_REGISTER,
      container: ContentDistributionRegisterEditContainer,
    },
    {
      id: Functions.CONTENT_DISTRIBUTION_USAGE_DETAIL,
      path: Path.CONTENT_DISTRIBUTION_USAGE_DETAIL,
      container: ContentDistributionUsageDetail,
    },
  ],

  [Path.SCORING]: [
    {
      id: Functions.SCORING_DISTRIBUTION_REPORT,
      path: Path.SCORING_DISTRIBUTION_REPORT,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_TOP,
      path: Path.SCORING_REPORT_TOP,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_LIST,
      path: Path.SCORING_REPORT_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_GET,
      path: Path.SCORING_REPORT_GET,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_CORRECTION,
      path: Path.SCORING_REPORT_CORRECTION,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_APPROVAL,
      path: Path.SCORING_REPORT_APPROVAL,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_REMAND,
      path: Path.SCORING_REPORT_REMAND,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_COLLECTION,
      path: Path.SCORING_REPORT_COLLECTION,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_REPORT_WITHDRAWAL,
      path: Path.SCORING_REPORT_WITHDRAWAL,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_ARCHIVEMENT_LIST,
      path: Path.SCORING_ARCHIVEMENT_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SCORING_ARCHIVEMENT_DETAIL,
      path: Path.SCORING_ARCHIVEMENT_DETAIL,
      container: ArchivementDetailContainer,
    },
    {
      id: Functions.SCORING_UNSUBMITTED_LIST,
      path: Path.SCORING_UNSUBMITTED_LIST,
      container: TabMenuContainer,
    },
  ],

  [Path.SERVICE_RECORD]: [
    {
      id: Functions.SERVICE_RECORD_COMPANY_LIST,
      path: Path.SERVICE_RECORD_COMPANY_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SERVICE_RECORD_SERVICE_LIST,
      path: Path.SERVICE_RECORD_SERVICE_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SERVICE_RECORD_SERVICES_LIST,
      path: Path.SERVICE_RECORD_SERVICES_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SERVICE_RECORD_DOWNLOAD_FORM,
      path: Path.SERVICE_RECORD_DOWNLOAD_FORM,
      container: TabMenuContainer,
    },
  ],

  [Path.USER_HISTORY]: [
    {
      id: Functions.USER_HISTORY_STUDENT_LIST,
      path: Path.USER_HISTORY_STUDENT_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.USER_HISTORY_CONTENT_LIST,
      path: Path.USER_HISTORY_CONTENT_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.USER_HISTORY_CONTENT_DETAIL,
      path: Path.USER_HISTORY_CONTENT_DETAIL,
      container: ContentHistoryDetailContainer,
    },
    {
      id: Functions.USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL,
      path: Path.USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL,
      container: ContentHistoryAggregateByProblemContainer,
    },
    {
      id: Functions.USER_HISTORY_STUDENT_DETAIL,
      path: Path.USER_HISTORY_STUDENT_DETAIL,
      container: UserHistoryStudentDetailContainer,
    },
    {
      id: Functions.USER_HISTORY_COURSE_LIST,
      path: Path.USER_HISTORY_COURSE_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.USER_HISTORY_COURSE_STUDENT_DETAIL,
      path: Path.USER_HISTORY_COURSE_STUDENT_DETAIL,
      container: UserHistoryStudentDetailContainer,
    },
    {
      id: Functions.USER_HISTORY_COURSE_STUDENT_RESULT,
      path: Path.USER_HISTORY_COURSE_STUDENT_RESULT,
      container: UserHistoryStudentResultContainer,
    },
    {
      id: Functions.USER_HISTORY_COURSE_DETAIL,
      path: Path.USER_HISTORY_COURSE_DETAIL,
      container: UserHistoryCourseDetailContainer,
    },
    {
      id: Functions.USER_HISTORY_STUDENT_RESULT,
      path: Path.USER_HISTORY_STUDENT_RESULT,
      container: UserHistoryStudentResultContainer,
    },
    {
      id: Functions.LEARNING_HISTORY_CSV_DOWNLOAD,
      path: Path.LEARNING_HISTORY_CSV_DOWNLOAD,
      container: LearningHistoryCSVDownloadContainer,
    },
    {
      id: Functions.PROGRESS_STATUS_CSV_DOWNLOAD,
      path: Path.PROGRESS_STATUS_CSV_DOWNLOAD,
      container: ProgressStatusCSVDownloadContainer,
    },
  ],

  [Path.MESSAGE_THREAD]: [
    {
      id: Functions.RECEIVED_MESSAGE_LIST,
      path: Path.RECEIVED_MESSAGE_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.SENT_MESSAGE_LIST,
      path: Path.SENT_MESSAGE_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.REGISTER_MESSAGE_THREAD,
      path: Path.REGISTER_MESSAGE_THREAD,
      container: RegisterMessageContainer,
    },
    {
      id: Functions.RECEIVE_CHAT_DETAIL,
      path: Path.RECEIVE_CHAT_DETAIL,
      container: ChatContainer,
    },
    {
      id: Functions.RECEIVE_MESSAGE_THREAD_DETAIL,
      path: Path.RECEIVE_MESSAGE_THREAD_DETAIL,
      container: MessageThreadDetailContainer,
    },
    {
      id: Functions.SENT_CHAT_DETAIL,
      path: Path.SENT_CHAT_DETAIL,
      container: ChatContainer,
    },
    {
      id: Functions.SENT_MESSAGE_THREAD_DETAIL,
      path: Path.SENT_MESSAGE_THREAD_DETAIL,
      container: MessageThreadDetailContainer,
    },
  ],
  [Path.LIVE]: [
    {
      id: Functions.LIVE_RESERVED_LIST,
      path: Path.LIVE_RESERVED_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.LIVE_RESERVED_REGISTER,
      path: Path.LIVE_RESERVED_REGISTER,
      container: LiveReservedRegisterContainer,
    },
    {
      id: Functions.LIVE_RESERVED_EDIT,
      path: Path.LIVE_RESERVED_EDIT,
      container: LiveReservedEditContainer,
    },
    {
      id: Functions.LIVE_RESERVED_DETAIL,
      path: Path.LIVE_RESERVED_DETAIL,
      container: LiveReservedDetailContainer,
    },
  ],
  [Path.EMAIL]: [
    {
      id: Functions.EMAIL_LIST,
      path: Path.EMAIL_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.RESERVED_EMAIL_LIST,
      path: Path.RESERVED_EMAIL_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.EMAIL_REGISTER,
      path: Path.EMAIL_REGISTER,
      container: EmailRegisterContainer,
    },
    {
      id: Functions.RESERVED_EMAIL_EDIT,
      path: Path.RESERVED_EMAIL_EDIT,
      container: EmailEditContainer,
    },
    {
      id: Functions.RESERVED_EMAIL_DETAIL,
      path: Path.RESERVED_EMAIL_DETAIL,
      container: ReservedEmailDetailContainer,
    },
  ],
  [Path.ADAPTIVE]: [
    {
      id: Functions.ADAPTIVE_META,
      path: Path.ADAPTIVE_META,
      container: AdaptiveMetaContainer,
    },
    {
      id: Functions.DISCRIMINATION_DEGREE_DATA,
      path: Path.DISCRIMINATION_DEGREE_DATA,
      container: DiscriminationDegreeDataContainer,
    },
  ],
  [Path.CONFIG_FILE]: [
    {
      id: Functions.DOWNLOAD_CONFIG_FILE,
      path: Path.DOWNLOAD_CONFIG_FILE,
      container: DownloadConfigFileContainer,
    },
    {
      id: Functions.UPLOAD_CONFIG_FILE,
      path: Path.UPLOAD_CONFIG_FILE,
      container: UploadConfigFileContainer,
    },
  ],

  /**
   * 多言語表示
   */
  [Path.MULTI_LANGUAGE]: [
    {
      id: Functions.MULTI_LANGUAGE_LIST,
      path: Path.MULTI_LANGUAGE_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.MULTI_LANGUAGE_PROCESS_RESULT_LIST,
      path: Path.MULTI_LANGUAGE_PROCESS_RESULT_LIST,
      container: TabMenuContainer,
    },
    {
      id: Functions.MULTI_LANGUAGE_PROCESS_DETAIL,
      path: Path.MULTI_LANGUAGE_PROCESS_DETAIL,
      container: MultiLanguageProcessDetailContainer,
    },
    {
      id: Functions.MULTI_LANGUAGE_EDIT,
      path: Path.MULTI_LANGUAGE_EDIT,
      container: MultiLanguageEditContainer,
    },
  ],

  /**
   * 受講者画面管理
   */
  [Path.USERFRONT]: [
    {
      id: Functions.USERFRONT_LOGIN_SCREEN_UPDATE,
      path: Path.USERFRONT_LOGIN_SCREEN_UPDATE,
      container: TabMenuContainer,
    },
    {
      id: Functions.USERFRONT_TOP_SCREEN_UPDATE,
      path: Path.USERFRONT_TOP_SCREEN_UPDATE,
      container: TabMenuContainer,
    },
    { // Step 11.0.0
      id: Functions.USERFRONT_TOP_SCREEN_UPDATE,
      path: Path.USERFRONT_CERTIFICATE_COMPLETION,
      container: TabMenuContainer,
    },
  ],

  /**
   * サービスグループ管理
   */
  [Path.SERVICE_GROUP]: [
    {
      id: Functions.SERVICE_GROUP_LIST,
      path: Path.SERVICE_GROUP_LIST,
      container: ServiceGroupTopContainer,
    },
    {
      id: Functions.SERVICE_GROUP_DETAIL,
      path: Path.SERVICE_GROUP_DETAIL,
      container: ServiceGroupDetailContainer,
    },
  ],

  /**
   * SuperUserサービスロール設定
   */
  [Path.SUPERUSER_SERVICE_ROLE]: [
    {
      id: Functions.SUPERUSER_SERVICE_ROLE_LIST,
      path: Path.SUPERUSER_SERVICE_ROLE_LIST,
      container: TabMenuContainer, // Step 11.0.0
    },
    {
      id: Functions.SUPERUSER_SERVICE_ROLE_EDIT,
      path: Path.SUPERUSER_SERVICE_ROLE_EDIT,
      container: SuperuserServiceRoleRegisterEditContainer,
    },
    {
      id: Functions.SUPERUSER_SERVICE_ROLE_REGISTER,
      path: Path.SUPERUSER_SERVICE_ROLE_REGISTER,
      container: SuperuserServiceRoleRegisterEditContainer,
    },
    {
      id: Functions.SUPERUSER_SERVICE_ROLE_DETAIL,
      path: Path.SUPERUSER_SERVICE_ROLE_DETAIL,
      container: SuperuserServiceRoleDetailContainer,
    },
  ],

  /**
   * SuperUser企業ロール設定
   */
  [Path.SUPERUSER_ENTERPRISE_ROLE]: [
    {
      id: Functions.SUPERUSER_ENTERPRISE_ROLE_LIST,
      path: Path.SUPERUSER_ENTERPRISE_ROLE_LIST,
      container: TabMenuContainer, // Step 11.0.0
    },
    {
      id: Functions.SUPERUSER_ENTERPRISE_ROLE_EDIT,
      path: Path.SUPERUSER_ENTERPRISE_ROLE_EDIT,
      container: SuperuserEnterpriseRoleRegisterEditContainer,
    },
    {
      id: Functions.SUPERUSER_ENTERPRISE_ROLE_REGISTER,
      path: Path.SUPERUSER_ENTERPRISE_ROLE_REGISTER,
      container: SuperuserEnterpriseRoleRegisterEditContainer,
    },
    {
      id: Functions.SUPERUSER_ENTERPRISE_ROLE_DETAIL,
      path: Path.SUPERUSER_ENTERPRISE_ROLE_DETAIL,
      container: SuperuserEnterpriseRoleDetailContainer,
    },
  ],

  /**
   * ログイン履歴ダウンロード
   */
  [Path.LOGIN_HISTORY]: [
    {
      id: Functions.LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD,
      path: Path.LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD,
      container: LoginHistoryCSVDownloadContainer,
    },
    {
      id: Functions.LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD,
      path: Path.LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD,
      container: LoginHistoryCSVDownloadContainer,
    },
  ],
};

export default ROUTE_CONFIG;
